export const alertDialogPreset = {
    name: 'mwAlert',
    methods: [
        'title',
        'htmlContent',
        'textContent',
        'content',
        'ariaLabel',
        'class',
        'ok'
    ],

    // mdDialogProvider expects options to be a function that returns the options object
    options: () => {
        'ngInject';
        return {
            controllerAs: '$ctrl',
            bindToController: true,
            clickOutsideToClose: false,
            escapeToClose: false,
            multiple: true,
            template: `
                <md-dialog class="mw-dialog" ng-class="$ctrl.class" aria-label="" >
                    <md-dialog-content class="mw-dialog__content">
                        <h2 class="mw-dialog__title md-title" mw-autotip>{{ $ctrl.title }}</h2>
                        <div ng-if="::$ctrl.mdHtmlContent" class="md-dialog-content-body" ng-bind-html="::$ctrl.mdHtmlContent"></div>
                        <div ng-if="::!$ctrl.mdHtmlContent" class="md-dialog-content-body">
                            <p class="mw-dialog__text-content">{{::$ctrl.mdTextContent}}</p>
                        </div>
                    </md-dialog-content>
                    <md-dialog-actions class="mw-dialog__actions" layout="row">
                        <div flex=""></div>
                        <md-button ng-click="$ctrl.handleOk()" class="mw-dialog__ok-button mw-button" md-autofocus="true">
                            {{ $ctrl.ok }}
                        </md-button>
                    </md-dialog-actions>
                </md-dialog>
            `,
            controller: class AlertDialog {
                constructor (private $mdDialog,
                             private $mdConstant) {
                    'ngInject';
                }

                handleOk() {
                    this.$mdDialog.hide(true);
                };
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/lib/components/dialog/alert/alert.dialog.preset.ts